import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle, Package, Home } from 'lucide-react';

const OrderSuccess = () => {
  return (
    <div className="order-success-page">
      <Card className="order-success-card">
        <div className="order-success-icon">
          <CheckCircle size={64} />
        </div>
        <h1 className="order-success-title">Order Placed Successfully!</h1>
        <p className="order-success-text">
          Thank you for your purchase. We've received your order and will begin processing it right away.
        </p>
        <p className="order-success-subtext">
          You will receive an email confirmation shortly with your order details and tracking information.
        </p>
        
        <div className="order-success-info">
          <div className="order-success-info-item">
            <Package size={24} />
            <div>
              <h3>Processing Time</h3>
              <p>1-2 business days</p>
            </div>
          </div>
          <div className="order-success-info-item">
            <Package size={24} />
            <div>
              <h3>Delivery Time</h3>
              <p>3-5 business days</p>
            </div>
          </div>
        </div>

        <div className="order-success-actions">
          <Button asChild size="lg">
            <Link to="/shop">
              <Home size={20} className="mr-2" />
              Continue Shopping
            </Link>
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default OrderSuccess;
